module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: ['reservation-modal', 'dark-top'],
    attrs: {
      "large": true
    },
    on: {
      "close": _vm.closeWindow
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Cancel Refund")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('div', {}, [_c('v-select', {
    attrs: {
      "options": _vm.getCancelRefundReasons,
      "label": "text",
      "placeholder": "Select reason"
    },
    model: {
      value: (_vm.selectedReason),
      callback: function($$v) {
        _vm.selectedReason = $$v
      },
      expression: "selectedReason"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('label', [_vm._v("Describe the refund cancelation reason")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonText),
      expression: "reasonText"
    }],
    staticClass: "w-100",
    domProps: {
      "value": (_vm.reasonText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reasonText = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    class: {
      'disabled notAllowed': _vm.isCancelRefundValid == false
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isCancelRefundValid
    },
    on: {
      "click": _vm.confirmClick
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Loading")]) : _c('span', [_vm._v("Confirm")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4399e2ca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/RefundCancel.vue
// module id = 1525
// module chunks = 0